import { formatRubles } from "../../../common/money";
import { formatUtcDateTime } from "../../../common/dateTime";

export const GAME_NAMES: Record<number, string> = {
    730: "CS2 / CS:GO",
    570: "Dota 2",
    440: "TF2",
    753: "Steam Items / Gifts",
    252490: "Rust",
};

export function gameName(gameId: number | null | undefined): string {
    if (gameId == null) {
        return "—";
    }
    return GAME_NAMES[gameId] ?? `Игра ${gameId}`;
}

export function toNum(value: number | bigint | string | null | undefined): number {
    if (value === null || value === undefined || value === "") {
        return 0;
    }
    if (typeof value === "bigint") {
        return Number(value);
    }
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
}

export function formatMoneyKopecks(kopecks: number | bigint | null | undefined): string {
    return formatRubles(toNum(kopecks));
}

/** Доля 0..1 → проценты ru-RU */
export function formatRatePercent(rate0to1: number | null | undefined, digits = 1): string {
    const n = Number(rate0to1 ?? 0);
    const pct = (Number.isFinite(n) ? n : 0) * 100;
    return `${pct.toLocaleString("ru-RU", {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
    })}%`;
}

export function formatInt(value: number | bigint | null | undefined): string {
    return toNum(value).toLocaleString("ru-RU");
}

/**
 * Часы до события (TTFD / TTFT).
 * json-bigint storeAsString: double с >15 знаками в JSON приходит строкой —
 * Number.isFinite(string) === false, без toNum метрика становится «—».
 */
export function formatHours(
    hours: number | bigint | string | null | undefined,
    sampleCount?: number | bigint | string | null
): string {
    if (sampleCount !== undefined && toNum(sampleCount) <= 0) {
        return "—";
    }
    if (hours === null || hours === undefined || hours === "") {
        return "—";
    }
    const n = toNum(hours);
    if (!Number.isFinite(n) || n < 0) {
        return "—";
    }
    if (n < 1 / 60) {
        return "< 1 мин";
    }
    if (n < 24) {
        return `${n.toFixed(1)} ч`;
    }
    return `${(n / 24).toFixed(1)} д`;
}

/** Дата с бэка в UTC → локаль админа */
export function formatUtcLocal(value: string | Date | null | undefined): string {
    if (value == null) {
        return "—";
    }
    return `${formatUtcDateTime(value)} (локальное время)`;
}

export function formatUtcLocalShort(value: string | Date | null | undefined): string {
    if (value == null) {
        return "—";
    }
    return formatUtcDateTime(value);
}

export function defaultPeriod(): { from: Date; to: Date } {
    const to = new Date();
    const from = new Date();
    from.setDate(from.getDate() - 7);
    from.setHours(0, 0, 0, 0);
    return { from, to };
}

export function toDatetimeLocalValue(date: Date): string {
    const tzOffsetMs = date.getTimezoneOffset() * 60000;
    const local = new Date(date.getTime() - tzOffsetMs);
    return local.toISOString().slice(0, 16);
}

export function fromDatetimeLocalValue(value: string): Date {
    return new Date(value);
}
